import { useGetPlaysQuery } from '@carboncopyco/data';
import {
  BrowserIcon,
  CanvasGraphicsIcon,
  TrendingOutlineIcon,
} from '@carboncopyco/icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { InfoPageSidebar } from '../InfoPageSidebar';
import { usePlaybookPageProps } from './PlaybookPageContext';
import type { PlaybookPageTab } from './types';

export const PlaybookPageSidebar = () => {
  const { rootPath, onGoBack, playbookId, organizationId, workspaceId } =
    usePlaybookPageProps();
  const { data: presentationsResponse, isLoading: isLoadingPresentations } =
    useGetPlaysQuery({
      organizationId,
      assetId: playbookId,
      workspaces: [workspaceId],
      assetType: 'playbook',
    });
  const flags = useFlags();

  const totalPresentations = presentationsResponse?.metadata.totalItems;

  const tabButtons = {
    overview: {
      label: 'Overview',
      icon: <BrowserIcon size={18} />,
    },
    presentations: {
      label:
        isLoadingPresentations || !totalPresentations
          ? 'Presentations'
          : `Presentations (${totalPresentations})`,
      icon: <CanvasGraphicsIcon size={18} />,
    },
    activity: {
      label: 'Activity',
      icon: <TrendingOutlineIcon size={18} />,
      disabled: !flags.playbookActivityTab,
    },
  };

  return (
    <InfoPageSidebar<PlaybookPageTab>
      tabButtons={tabButtons}
      screenshot=""
      goBack={onGoBack}
      rootPath={rootPath}
      isPlaybook
    />
  );
};
